// pages/ArtSchool.jsx
import React from 'react';
import { Link } from 'react-router-dom';

// Import images
import School3 from '../images/schools/school3.jpg';
import School4 from '../images/schools/school4.jpg';
import School5 from '../images/schools/school5.jpg';

const ArtSchool = () => {
    // Art courses offered
    const courses = [
        {
            id: 1,
            title: "Folk Art Fundamentals",
            level: "Beginner",
            description: "Learn the basics of traditional Bengali folk art techniques and motifs.",
            image: School4
        },
        {
            id: 2,
            title: "Mythology in Modern Art",
            level: "Intermediate",
            description: "Explore how to incorporate mythological themes in contemporary artwork.",
            image: School5
        },
        {
            id: 3,
            title: "Advanced Painting Techniques",
            level: "Advanced",
            description: "Master the fusion of traditional and modern painting methods.",
            image: School3
        }
    ];

    return (
        <div className="container">
            <div className="section-header" style={{ textAlign: 'center', marginBottom: '3rem' }}>
                <h2 className="section-title">Art House & Art Gallery</h2>
                <p style={{ maxWidth: '800px', margin: '0 auto', fontSize: '1.1rem' }}>
                    Learn the art of folk modernism through Samir Dutta's specialized courses and workshops,
                    designed for artists of all skill levels.
                </p>
            </div>

            {/* School Introduction */}
            <section className="section">
                <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '2rem',
                    alignItems: 'center'
                }}>
                    <div style={{ flex: '1', minWidth: '300px' }}>
                        <h3 style={{ color: 'var(--primary-color)', marginBottom: '1rem' }}>About the Art School</h3>
                        <p style={{ marginBottom: '1rem' }}>
                            Founded by Samir Dutta, our art school provides a nurturing environment for artists to explore
                            the rich traditions of Bengali folk art while developing their unique contemporary voice.
                        </p>
                        <p>
                            With over 20 years of teaching experience at prestigious institutions like
                            Birla Academy Art and Culture and Nehru Children Museum, Samir brings unparalleled expertise
                            to his courses, helping students master both technical skills and artistic expression.
                        </p>
                    </div>
                    <div style={{
                        flex: '1',
                        minWidth: '300px',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        boxShadow: '0 5px 15px rgba(0, 0, 0, 0.1)'
                    }}>
                        <img
                            src={School4}
                            alt="Samir Dutta Art School"
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                    </div>
                </div>
            </section>

            {/* Courses Section */}
            <section className="section">
                <h3 style={{
                    fontSize: '1.8rem',
                    marginBottom: '1.5rem',
                    color: 'var(--primary-color)',
                    textAlign: 'center'
                }}>
                    Art Courses
                </h3>

                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                    gap: '2rem',
                    margin: '2rem 0'
                }}>
                    {courses.map((course) => (
                        <div key={course.id} className="slide-up" style={{
                            backgroundColor: 'white',
                            borderRadius: '8px',
                            overflow: 'hidden',
                            boxShadow: '0 5px 15px rgba(0, 0, 0, 0.1)',
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column'
                        }}>
                            <div style={{ height: '200px' }}>
                                <img
                                    src={course.image}
                                    alt={course.title}
                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                />
                            </div>
                            <div style={{
                                padding: '1.5rem',
                                flex: '1',
                                display: 'flex',
                                flexDirection: 'column'
                            }}>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    marginBottom: '0.5rem'
                                }}>
                                    <span style={{
                                        backgroundColor: 'var(--accent-color)',
                                        color: 'white',
                                        padding: '0.2rem 0.8rem',
                                        borderRadius: '4px',
                                        fontSize: '0.8rem'
                                    }}>
                                        {course.level}
                                    </span>
                                </div>
                                <h4 style={{
                                    color: 'var(--primary-color)',
                                    marginBottom: '0.5rem'
                                }}>
                                    {course.title}
                                </h4>
                                <p style={{ flex: '1' }}>
                                    {course.description}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* Enrollment CTA */}
            <section style={{
                textAlign: 'center',
                margin: '3rem 0',
                padding: '3rem',
                backgroundColor: 'white',
                borderRadius: '8px',
                boxShadow: '0 5px 15px rgba(0, 0, 0, 0.05)'
            }}>
                <h3 style={{ color: 'var(--primary-color)', marginBottom: '1rem' }}>Enroll Today</h3>
                <p style={{ maxWidth: '600px', margin: '0 auto 2rem' }}>
                    Begin your artistic journey with Samir Dutta and explore the rich traditions
                    of folk art with a contemporary perspective.
                </p>
                <Link to="/contact" className="btn">
                    Contact for Enrollment
                </Link>
            </section>
        </div>
    );
};

export default ArtSchool;